module.exports = require('./_global');


//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201706121922-6a92b31330-master/~/core-js/modules/_path.js
// module id = 629
// module chunks = 1